import React from "react";
import { useAppContext } from "../context/AppContext";

const ADAGuidelines: React.FC = () => {
  const { state } = useAppContext();

  if (!state.settings.adaGuidelines) {
    return null;
  }

  return (
    <div 
      className="fixed left-0 right-0 pointer-events-none z-50"
      style={{ bottom: '460px' }}
    >
      <div 
        className="w-full h-0.5 bg-red-500"
        style={{ 
          boxShadow: '0 0 2px rgba(239, 68, 68, 0.5)' 
        }}
      />
      <div className="absolute right-4 -top-6">
        <div className="bg-red-500 text-brand-background px-2 py-1 text-xs font-medium rounded">
          ADA 460px
        </div>
      </div>
    </div>
  );
};

export default ADAGuidelines;

